var base = require('settings/api/create-token');

Vue.component('spark-create-token', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/api/create-token.js